export enum EEmVatReportType {
	OSS_UNION = 'OSS_UNION',
	OSS_NON_UNION = 'OSS_NON_UNION',
	DOMESTIC = 'DOMESTIC',
	GIFTCARD_SCHEME = 'GIFTCARD_SCHEME',
	B2B = 'B2B',
	OSS_IMPORT = 'OSS_IMPORT',
	NON_EU_COUNTRY_IMPORT = 'NON_EU_COUNTRY_IMPORT',
	FC_REP = 'FC_REP',
}

export const EM_VAT_REPORT_TYPE_LABEL: Record<EEmVatReportType, string> = {
	[EEmVatReportType.OSS_UNION]: 'UNION',
	[EEmVatReportType.OSS_NON_UNION]: 'NON-UNION',
	[EEmVatReportType.DOMESTIC]: 'Domestic',
	[EEmVatReportType.GIFTCARD_SCHEME]: 'Gift cards',
	[EEmVatReportType.B2B]: 'B2B sales',
	[EEmVatReportType.OSS_IMPORT]: 'IOSS',
	[EEmVatReportType.NON_EU_COUNTRY_IMPORT]: 'GB Import',
	[EEmVatReportType.FC_REP]: 'FC representation',
};
